import { EventStreamCodec } from '@smithy/eventstream-codec';
import { fromUtf8, toUtf8 } from '@smithy/util-utf8';

export const SAMPLE_RATE = 44100;
export const mediaStreamCodec = new EventStreamCodec(toUtf8, fromUtf8);

export function concatUint8Arrays(chunks: Uint8Array[]): Uint8Array {
  const total = chunks.reduce((acc, curr) => acc + curr.length, 0);
  const result = new Uint8Array(total);
  let offset = 0;

  // eslint-disable-next-line no-restricted-syntax
  for (const chunk of chunks) {
    result.set(chunk, offset);
    offset += chunk.length;
  }
  return result;
}

export function getSilentFrame(durationMs = 4) {
  const samples = Math.floor(SAMPLE_RATE * (durationMs / 1000));
  const silentPcm = new Int16Array(samples); // 16-bit signed PCM, all zeros = silence
  return new Uint8Array(silentPcm.buffer);
}
